/**
 * One public function:  logEvent(eventKey, opts)
 *
 *  • Adds advertiser analytics boilerplate
 *  • Looks up the default category from EVENT_CONFIG
 *  • Delegates to the existing trackEvent()
 */

import { trackEvent } from '../analytics/index.js' // ← your current helper
import { EVENT_CONFIG, EVENT_CATEGORIES } from './constants.js'
import { advertiserAnalyticOptions } from '../utils/functions.js'

/**
 * @param {string} eventKey  – key from EVENTS
 * @param {object} payload   – dynamic values (label, section, …)
 * @param {object} extras    – optional flags: { searchParams, isSeeker, isJobPostedSuccessfully }
 */
export function logEvent(eventKey, payload = {}, extras = {}) {
  const cfg = EVENT_CONFIG[eventKey] || {}
  const category = cfg.category || EVENT_CATEGORIES.TAP

  const options = advertiserAnalyticOptions({
    category,
    ...payload // label / field_name / section / submission_id …
  })

  trackEvent({
    name: eventKey,
    options,
    searchParams: extras.searchParams || {},
    isSeeker: !!extras.isSeeker,
    isJobPostedSuccessfully: !!extras.isJobPostedSuccessfully
  })
}
